import axios from 'axios';
import { URLEndpoints } from '../../constants/urlConstants';
const BASE_URL = process.env.REACT_APP_NODEJS_SERVER_URL
const token = localStorage.getItem('accessToken');

const getAuthHeaders = () => {
  const accessToken = String(localStorage.getItem('accessToken') || '').trim();
  if (!accessToken) return {};

  return {
    Authorization: accessToken.startsWith('Bearer ')
      ? accessToken
      : `Bearer ${accessToken}`,
    accessToken,
  };
};

export const createEstimationApi = async (payload) => {
    try {
        const res = await axios.post(`${BASE_URL}/${URLEndpoints.Estimation}`, payload,
        { headers: { Authorization: `Bearer ${token}` } })
        return res?.data
    } catch (error) {
        console.log(error)
    }
}
export const updateEstimation = async (id,payload) => {
    try {
        const res = await axios.put(`${BASE_URL}/${URLEndpoints.Estimation}/${id}`, payload,
        { headers: { Authorization: `Bearer ${token}` } })
        return res
    } catch (error) {
        console.log(error)
        throw error
    }
}

export const updateEstimationInHandsDate = async (id, inhandsDate) => {
    try {
        const res = await axios.patch(
            `${BASE_URL}/${URLEndpoints.Estimation}/${id}/in-hands-date`,
            { inhandsDate },
            { headers: getAuthHeaders() }
        );
        return res;
    } catch (error) {
        console.log(error);
        throw error;
    }
}

export const submitPublicSalesOrderAction = async (id, payload) => {
    const res = await axios.post(
        `${BASE_URL}/${URLEndpoints.Estimation}/${id}/public-action`,
        payload
    );
    return res;
}

export const sendEstimationEmail = async (id, instanceUniqueId, email) => {
  const res = await axios.post(
    `${BASE_URL}/${URLEndpoints.Estimation}/${id}/send-mail`,
    { instanceUniqueId, email },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return res?.data;
};

export const fetchEstimationDetails = async (id, options = {}) => {
  const params = {};

  if (options?.snapshotRevision) {
    params.snapshotRevision = options.snapshotRevision;
  }

  if (options?.snapshotId) {
    params.snapshotId = options.snapshotId;
  }
  if (options?.documentType) {
    params.documentType = options.documentType;
  }

  const response = await axios.get(
    `${BASE_URL}/${URLEndpoints.Estimation}/${id}`,
    {
      params,
      headers: getAuthHeaders(),
    }
  );

  return response.data;
};

export const preflightGeneratedSalesOrderArtwork = async (id) => {
  const response = await axios.get(
    `${BASE_URL}/${URLEndpoints.Estimation}/${id}/artwork-preview-preflight`,
    { headers: getAuthHeaders() }
  );
  return response?.data || { previews: [] };
};
      
      
      

export const updateComment = async (payload) => {
    try {
        const res = await axios.patch(`${BASE_URL}/${URLEndpoints.Estimation}/${URLEndpoints.salesOrderComments}/`,payload)
        return res?.data
    } catch (error) {
        console.log(error)
        throw error
    }
}
export const getProductComments = async (presentationId, productId) => {
    try {
        const response = await axios.get(`${BASE_URL}/presentation-comment/`,
            {
                params: {
                    presentationId: presentationId || 94,
                    productId: productId || 553546514,
                },
            }
        );
        return response.data;
    } catch (error) {
        throw new Error('Error fetching comments');
    }
};

export const editComment = async (commentId, updatedComment) => {
    try {
      const response = await axios.put(`${BASE_URL}/presentation-comment/${commentId}`, {
        comment: updatedComment,
      });
      return response.data;
    } catch (error) {
      console.error('Error editing comment:', error);
      throw error; 
    }
  };
  
  // Delete comment function
  export const deleteComment = async (commentId) => {
    try {
      const response = await axios.delete(`${BASE_URL}/presentation-comment/${commentId}`);
      return response.data; 
    } catch (error) {
      console.error('Error deleting comment:', error);
      throw error; 
    }
  };

export const fetchLatestCompletedSalesOrderForOrder = async (orderId) => {
    if (!orderId) return null;
    try {
      const res = await axios.get(
        `${BASE_URL}/${URLEndpoints.Estimation}/by-order/${orderId}/completed-latest`
      );
      return res?.data?.salesOrder || null;
    } catch (e) {
      if (e?.response?.status !== 404) {
        console.warn("[fetchLatestCompletedSalesOrderForOrder] failed:", e?.message);
      }
      return null;
    }
  };

export const fetchEstimatesForOrder = async (orderId) => {
  if (!orderId) return [];
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.Estimation}/by-order/${orderId}`);
  const rows = Array.isArray(res?.data?.salesOrders) ? res.data.salesOrders : [];
  return rows.filter((row) => ["1", "1_sent"].includes(String(row?.status)));
};

export const fetchSalesOrdersForOrder = async (orderId) => {
  if (!orderId) return [];
  const res = await axios.get(`${BASE_URL}/${URLEndpoints.Estimation}/by-order/${orderId}`);
  const rows = Array.isArray(res?.data?.salesOrders) ? res.data.salesOrders : [];
  return rows.filter((row) => !["1", "1_sent"].includes(String(row?.status)));
};
